import { Controller } from "@hotwired/stimulus"

// Live-polled progress for the GridSignal per-project coordinate
// backfill. There's no SeedRun-style progress row for enrichment
// jobs — the state is just "how many Projects have latitude set
// vs don't," which lives in the gs_projects table itself. The
// controller just repolls that count every few seconds and patches
// the counter + progress bar in place, so the admin can watch the
// backfill drain in real time after clicking Backfill coordinates
// instead of guessing whether anything is happening.
export default class extends Controller {
  static values = { url: String, intervalMs: { type: Number, default: 3000 } }
  static targets = ["withCoords", "total", "missing", "percent", "cost", "bar"]

  connect() {
    this.poll()
    this.timer = setInterval(() => this.poll(), this.intervalMsValue)
  }

  disconnect() {
    if (this.timer) clearInterval(this.timer)
  }

  async poll() {
    try {
      const res = await fetch(this.urlValue, { headers: { "Accept": "application/json" } })
      if (!res.ok) return
      const data = await res.json()

      if (this.hasWithCoordsTarget) this.withCoordsTarget.textContent = data.with_coords
      if (this.hasTotalTarget)      this.totalTarget.textContent      = data.total
      if (this.hasMissingTarget)    this.missingTarget.textContent    = data.missing
      if (this.hasPercentTarget)    this.percentTarget.textContent    = (data.percent ?? 0).toFixed(1)
      if (this.hasCostTarget)       this.costTarget.textContent       = (data.est_cost_usd ?? 0).toFixed(2)
      if (this.hasBarTarget) {
        this.barTarget.style.width = `${data.percent ?? 0}%`
        // Flip the bar green on 100% so the admin visually sees "done."
        this.barTarget.style.background = data.missing === 0 ? "#16a34a" : "#2563eb"
      }
    } catch (_e) {
      // Transient — poll will retry on the next tick.
    }
  }
}
